import './App.css';

function App() {
  return (
    <iframe
      title="shorts"
      id="player"
      type="text/html"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      referrerpolicy="strict-origin-when-cross-origin"
      allowfullscreen
      src="https://www.youtube.com/embed?v=Zg7gcVgEI4I&list=PL979KzsF8hRNIdZvPDOiPH683RXQKdAjm&amp;controls=0&amp;autoplay=1&amp;loop=1"
    ></iframe>
  );
}

export default App;
